import Action from "../../classes/Action";
import store, { StoreActions } from '../../state/store';
import { StepUIData } from "../../interfaces/UITemplateData";
import Step from "../../classes/scenarioElements/Step";

export default class CreateTemplateFromStep extends Action
{
	constructor(step: Step, newSlideId: string)
	{
		const newSlide: StepUIData = store.getState().uiModule.ui[step.id];

		super(
			[step, newSlideId],
			[newSlideId],
			`Create Template from step`,
			[newSlide]
		);
	}

	do(step: Step, slideId: string)
	{
		//synced - bool
		//slide - slide id
		const slideTemplate = { ...store.getState().uiModule.ui[step.id], name: `(${step.sequence.name}).(${step.name})_Template`, type: 'slide' };
		delete slideTemplate.synced;
		store.dispatch(StoreActions.ui.setSlideFromCopy({ slide: slideId, content: { ...slideTemplate }, sourceStepId: step.id }));
	}

	undo(slideId: string)
	{
		store.dispatch(StoreActions.ui.deleteSlide({ id: slideId }));
	}

	verify(newSlide: StepUIData)
	{
		if (!newSlide) return false;
		return true;
	}
}
